<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text class="p-3" style="color: #4F4F4F">
        <ProductCardSubscriptionRow :is-subscribed="isSubscribed" :name="product.name" />
        <v-row class="pl-3">
          Setup:
        </v-row>
        <v-row class="pl-3">
          <div>
            <ul class="pb-3">
              <li style="text-align: left">
                Complete the certificate in the HawkSoft Cert Wizard just like today
              </li>
              <li style="text-align: left">
                Click Publish
              </li>
              <li style="text-align: left">
                Copy the link and email or text it to the insured
              </li>
              <li style="text-align: left">
                The insured can generate certificates using the new cert holders already in your system, or they add their own cert holders.
                <ul>
                  <li style="text-align: left">Works on mobile devices</li>
                  <li style="text-align: left">Notifications are automatically sent to the agency of record on any certificates that your insureds generate or email to their cert holders</li>
                </ul>
              </li>
            </ul>
          </div>
        </v-row>

        <v-row class="pl-3">
          <div style="text-align: left" class="pt-3">
            If you would like to subscribe to the Self-service Certificates service, or to change your subscription, please contact the HawkSoft Sales Team.
          </div>
        </v-row>

      </v-card-text>

      <!-- Return to marketplace -->
      <v-card-actions>
        <v-row class="pa-3">
          <v-btn @click="returnToMarketplace()">Return to Marketplace</v-btn>
        </v-row>
      </v-card-actions>

    </v-card>
  </v-col>
</template>

<style scoped>
.left {
    text-align: left;
    margin: 0 auto;
}
</style>

<script>
import { mapGetters } from 'vuex';
import productIdMappingMixin from '../../../mixins/productIdMappingMixin';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import ProductCardSubscriptionRow from '@/components/products/shared/ProductCardSubscriptionRow';

export default {
  name: 'SelfServeCertsCorporate',
  components: {
    ProductCardHeader,
    ProductCardSubscriptionRow
  },
  mixins: [productIdMappingMixin],
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('selfCertsCorp'));
    },
    isSubscribed () {
      var product = this.getProductByProductId(this.getProductId('selfCertsCorp'));
      if (product) {
        return product.isSubscribed;
      }
      return false;
    }
  },
  methods: {
    returnToMarketplace () {
      this.$router.push('/marketplace');
    }
  }
};

</script>
